import { useMutation } from "@tanstack/react-query";
import { createGameLesson } from "api/services/game-lesson-service";
import { ICreateGameLessonRequest } from "api/models/request/ICreateGameLessonRequest";
import { useAuthContext } from "hooks/useAuthContext";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

export const useCreateGameLesson = () => {
    const { userState } = useAuthContext();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (params: ICreateGameLessonRequest) => {
            const workspaceId = userState.user.selectedWorkspace.workspaceId;
            if (!workspaceId) throw new Error("No workspace selected");
            const response = await createGameLesson({ ...params, workspaceId });
            if (!response.success) {
                throw new Error(response.message ?? "addLesson.error");
            }
            return response;
        },
        onSuccess: () => {
            enqueueSnackbar(t("addLesson.success"), { variant: "success" });
        },
        onError: () => {
            enqueueSnackbar(t("addLesson.error"), { variant: "error" });
        },
    });

    return { createGameLesson: mutation.mutateAsync };
};
